import React from "react";

const InputBox = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  type = "text",
  placeholder,
  required = false,
  disabled = false,
  className = "",
}) => {
  return (
    <div className={className}>
      {label && (
        <label className="text-sm font-medium">{label}{required && <span className="text-red-500">*</span>}</label>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder || label?.replace("*", "")}
        className="mt-0.5 w-full border border-[#D1D5DB] rounded-md px-4 py-2 focus:ring-2 focus:ring-[#1976D2] outline-none disabled:bg-gray-100"
      />
    </div>
  );
};

export default InputBox;
